import { render, staticRenderFns } from "./PersonnelRecordStatusChip.vue?vue&type=template&id=2962db68"
import script from "./PersonnelRecordStatusChip.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports